// removed by extract-text-webpack-plugin
module.exports = {"TabsWrapper":"TabsWrapper-module__TabsWrapper__3Z7vD"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Layout/TabsWrapper/TabsWrapper.module.css
// module id = 1799
// module chunks = 31